// Email Service for sending emails via Supabase Edge Function

/**
 * Email Service for sending emails via Supabase Edge Function
 * Uses Resend API on the backend
 */
export class EmailService {
    static FUNCTION_URL = `${process.env.REACT_APP_SUPABASE_URL || 'https://oatvjejpmvxkhxnfnvgq.supabase.co'}/functions/v1/send-email`;
    static INTERNAL_API_KEY = process.env.REACT_APP_INTERNAL_API_KEY || '';

    /**
     * Send wizard submission confirmation email to user and admin
     * @param {Object} submission - The wizard submission data
     * @returns {Promise<{success: boolean, error?: string}>}
     */
    static async sendWizardConfirmation(submission) {
        try {
            if (!submission?.email && !submission?.personalInfo?.email) {
                console.warn('No email address found in submission, skipping email');
                return { success: false, error: 'No email address' };
            }

            const response = await fetch(this.FUNCTION_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-internal-key': this.INTERNAL_API_KEY,
                },
                body: JSON.stringify({
                    type: 'wizard_confirmation',
                    submission
                }),
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || `HTTP ${response.status}`);
            }

            const result = await response.json();
            console.log('✅ Wizard confirmation email sent:', result);
            return { success: true, ...result };
        } catch (error) {
            console.error('❌ Failed to send wizard confirmation email:', error);
            return { success: false, error: error.message };
        }
    }

    /**
     * Send a custom email
     * @param {string} to - Recipient email address
     * @param {string} subject - Email subject
     * @param {string} html - HTML content
     * @returns {Promise<{success: boolean, error?: string}>}
     */
    static async sendCustomEmail(to, subject, html) {
        try {
            const response = await fetch(this.FUNCTION_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-internal-key': this.INTERNAL_API_KEY,
                },
                body: JSON.stringify({
                    type: 'custom',
                    to,
                    subject,
                    html
                }),
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || `HTTP ${response.status}`);
            }

            const result = await response.json();
            console.log('✅ Custom email sent:', result);
            return { success: true, ...result };
        } catch (error) {
            console.error('❌ Failed to send custom email:', error);
            return { success: false, error: error.message };
        }
    }

    /**
     * Send a follow-up reminder email to a lead
     * @param {Object} lead - Lead data with email and name
     * @param {string} message - Custom message to include
     * @returns {Promise<{success: boolean, error?: string}>}
     */
    static async sendFollowUpReminder(lead, message) {
        const name = lead.first_name || 'there';
        const html = `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <h2 style="color: #1e3a5f;">Hi ${name}!</h2>
        <p style="color: #4b5563; line-height: 1.6;">${message}</p>
        <p style="color: #4b5563;">
          If you have any questions, feel free to reply to this email or call us.
        </p>
        <p style="color: #1e3a5f; font-weight: 600;">
          Best regards,<br>
          The Ravana Migration Team
        </p>
      </div>
    `;

        return this.sendCustomEmail(
            lead.email,
            `Following up on your migration inquiry, ${name}`,
            html
        );
    }
}

export default EmailService;
